import { AnyAction, Reducer } from 'redux';

// export const STORE_DRAFTORDER = 'file/files-upload';
export const STORE_LIVEORDERDATA = 'all-data/live-order';
export const STORE_LIVEORDERDATA_ONHOLD = 'onHold/live-order';
export const STORE_LIVEORDERDATA_RETURNED = 'returned/live-order';
export const STORE_LIVEDATA_ORDERNO = 'data/live-order-no';
export const STORE_VIEWORDERDATA = 'data/view-order-data';
export const STORE_LIVEDATA_ORDERID = 'data/view-order-id';
export const STORE_CANCELORDERDATA = 'all-data/cancel-order';
export const STORE_NEWORDERDATA = 'all-data/new-order';
export interface RowDataLive {
    rowno: string;
    orderno: string;
    orderdate: string;
    fname: string;
    fpath: string;
    feedback: string;
    filesize: string;
    vfiles: string;
    material: string;
    servicename: string;
    designtype: string;
    tat: string;
    msg: string;
    msgcnt: string;
    nounits: string;
    status: string;
    completedon: string;
    final_scan_url: string;
    customerstatus: string;
    fdownload: string;
    qc_required: string;
    labname: string;
    destination: string;
    filetag: string;
    refno: string;
}

export interface RowDataCancel {
    rowno: string;
    orderno: string;
    orderdate: string;
    cancelledon: string;
    cancelremarks: string;
    filesize: string;
    material: string;
    servicename: string;
    designtype: string;
    tat: string;
    msg: string;
    status: string;
    normal_smile_url: string;
    wide_smile_url: string;
    final_smile_url: string;
    final_scan_url: string;
    qc_rating: string;
    qc_remarks: string;
    normalsmilefile: string;
    widesmailfile: string;
    finalsmilefile: string;
    ds_ordersid: string;
    qcuname: string;
    dueby: string;
    labname: string;
    completedon: string;
    ifname: string;
    fname: string;
    fpath: string;
    fdownload: string;
    qc_required: string;
    downloadedon: string;
}
export interface ViewOrderData {
    rowno: string;
    orderno: string;
    orderdate: string;
    fname: string;
    fpath: string;
    filesize: string;
    material: string;
    servicename: string;
    designtype: string;
    tat: string;
    msg: string;
    nounits: string;
    status: string;
    normal_smile_url: string;
    wide_smile_url: string;
    final_smile_url: string;
    final_scan_url: string;
    qc_rating: string;
    qc_remarks: string;
    normalsmilefile: string;
    widesmailfile: string;
    finalsmilefile: string;
    ds_ordersid: string;
    p_name: string;
    p_age: string;
    p_gender: string;
    qcuname: string;
    dueby: string;
    labname: string;
}

export interface LiveOrderState {
    newOrderData: RowDataLive[];
    liveOrderData: RowDataLive[];
    liveOrderDataOnHold: RowDataLive[];
    liveOrderDataReturned: RowDataLive[];
    orderno: string;
    orderid: string;
    viewOrderData: ViewOrderData[];
    cancelOrderData: RowDataCancel[];
}

const initialState: LiveOrderState = {
    // files: [],
    newOrderData: [],
    liveOrderData: [],
    liveOrderDataOnHold: [],
    liveOrderDataReturned: [],
    cancelOrderData: [],
    orderno: '',
    orderid: '',
    viewOrderData: [
        {
            rowno: '',
            orderno: '',
            orderdate: '',
            fname: '',
            fpath: '',
            filesize: '',
            material: '',
            servicename: '',
            designtype: '',
            tat: '',
            msg: '',
            nounits: '',
            status: '',
            normal_smile_url: '',
            wide_smile_url: '',
            final_smile_url: '',
            final_scan_url: '',
            qc_rating: '',
            qc_remarks: '',
            normalsmilefile: '',
            widesmailfile: '',
            finalsmilefile: '',
            ds_ordersid: '',
            p_name: '',
            p_age: '',
            p_gender: '',
            qcuname: '',
            dueby: '',
            labname: ''
        }
    ]
};

const reducer: Reducer<LiveOrderState> = (
    state: LiveOrderState = initialState,
    action: AnyAction
): LiveOrderState => {
    switch (action.type) {
        case STORE_LIVEORDERDATA:
            return {
                ...state,
                liveOrderData: action.liveOrderData
            };
        case STORE_LIVEORDERDATA_ONHOLD:
            return {
                ...state,
                liveOrderDataOnHold: action.liveOrderDataOnHold
            };
        case STORE_LIVEORDERDATA_RETURNED:
            return {
                ...state,
                liveOrderDataReturned: action.liveOrderDataReturned
            };
        case STORE_CANCELORDERDATA:
            return {
                ...state,
                cancelOrderData: action.cancelOrderData
            };
        case STORE_NEWORDERDATA:
            return {
                ...state,
                newOrderData: action.newOrderData
            };
        case STORE_LIVEDATA_ORDERNO:
            return {
                ...state,
                orderno: action.orderno
            };
        case STORE_LIVEDATA_ORDERID:
            return {
                ...state,
                orderid: action.orderid
            };
        case STORE_VIEWORDERDATA:
            return {
                ...state,
                viewOrderData: action.viewOrderData
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/liveorderfile.tsx